export const fileToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    const result = reader.result;
    if (typeof result === 'string') {
      const base64 = result.includes(',') ? result.split(',')[1] : result;
      resolve(base64);
    } else {
      resolve('');
    }
  };
  reader.onerror = reject;
  reader.readAsDataURL(file);
});

